<script setup lang="ts">
interface IIconProps {
  path: string | string[];
  size?: number;
  filled?: boolean;
  stroked?: boolean;
  bindings?: Record<string, unknown> | null;
  pathBindings?: Record<string, unknown> | null;
  class?: string | string[] | { [key: string]: boolean };
}

const props = withDefaults(defineProps<IIconProps>(), {
  path: '',
  size: 24,
  filled: false,
  stroked: false,
  bindings: null,
  pathBindings: null,
  class: '',
});

const fullBindings = computed(() => {
  return {
    fill: props.filled ? 'currentColor' : 'none',
    stroke: props.stroked ? 'currentColor' : '',
    viewBox: `0 0 ${props.size} ${props.size}`,
    width: props.size,
    height: props.size,
    class: 'w-full h-full ' + props.class,
    ...props.bindings,
  };
});
</script>
<template>
  <svg
    v-if="Array.isArray(props.path)"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="fullBindings"
    aria-hidden="true"
  >
    <path
      v-for="(svgPath, index) in props.path"
      :key="index"
      stroke-linecap="round"
      stroke-linejoin="round"
      :d="svgPath"
      v-bind="pathBindings"
    ></path>
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    v-bind="fullBindings"
    aria-hidden="true"
  >
    <slot />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      :d="path as string"
      v-bind="pathBindings"
    />
  </svg>
</template>
